import React, { createContext } from 'react';

const EditorContext = createContext({});
const BaseColorPickerContext = createContext({});

export { EditorContext, BaseColorPickerContext };
